'use client'

import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useLookupsStore } from '@repo/store/useLookupsStore'

type MarketingMailingCategoriesSelectProps = {
  testData?: any[] | null
  value?: any
  onChange?: (val: any) => void
  sx?: Record<string, any>
  size?: string
  required?: boolean
  errors?: Record<string, any>
  clearable?: boolean
}

export const MarketingMailingCategoriesSelect = ({
  testData = null,
  value = null,
  onChange = (val: any) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required,
  errors = {},
  clearable
}: MarketingMailingCategoriesSelectProps) => {
  const { fetchAllMarketingMailingCategories, marketingMailingCategories } = useLookupsStore()
  const [options, setOptions] = useState(testData || marketingMailingCategories || [])
  const [selectedValue, setSelectedValue] = useState(value)

  useEffect(() => {
    if (testData) return
    setOptions(marketingMailingCategories || [])
  }, [testData, marketingMailingCategories])

  useEffect(() => {
    if (testData || marketingMailingCategories?.length) return
    fetchAllMarketingMailingCategories()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, marketingMailingCategories])

  useEffect(() => {
    if (typeof value === 'number' || typeof value === 'string') {
      const selectedOption = options.find((option: any) => String(option.marketingMailingCategoryId) === String(value))
      if (selectedOption) {
        setSelectedValue(selectedOption)
      }
    } else {
      setSelectedValue(value)
    }
  }, [value, options])

  return (
    <div data-testid="MarketingMailingCategoriesSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%', ...sx }}>
      <ReactSelectMenu
        label="Marketing mailing category"
        onChange={(newVal: any) => {
          onChange(newVal)
          setSelectedValue(newVal)
        }}
        labelKey="description"
        valueKey="marketingMailingCategoryId"
        items={options}
        value={selectedValue}
        searchable
        idLabelKey="marketingMailingCategoryId"
        showIdInResults={false}
        name="marketingMailingCategory"
        size={size}
        required={required}
        errors={errors}
        clearable={clearable}
      />
    </div>
  )
}
